import {RouteComponentProps, withRouter} from "react-router";
import * as React from "react";
import {Link} from "react-router-dom";

/* tslint:disable:interface-name */
export interface DetailPageProps extends RouteComponentProps<{}, {}, {}>{
    totalResults: number,
    currentPage: number,
    pageSize: number,
    search: string,
    entityId: string,
}

class Pagination extends React.Component<DetailPageProps, {}> {

    public render() {
        return <div className="nav-links text-center">
            {this.renderPrevious()}
            {this.renderFirst()}
            {this.renderPreviousEllipsis()}
            {this.renderPreviousNumber()}
            {this.renderCurrent()}
            {this.renderNextNumber()}
            {this.renderNextEllipsis()}
            {this.renderLast()}
            {this.renderNext()}
        </div>;
    }

    private renderFirst() {
        if (this.props.currentPage >= 3) {
            return <Link className="page-numbers" to={this.getLink(1)}>1</Link>
        }
        return undefined;
    }

    private renderPrevious() {
        if (this.props.currentPage > 1) {
            return <Link className="prev page-numbers" to={this.getLink(this.props.currentPage -1)}>Vorige</Link>
        }
        return undefined;
    }

    private renderPreviousEllipsis() {
        if (this.props.currentPage >= 4) {
            return <span className="page-numbers">&#8230;</span>
        }
        return undefined;
    }

    private renderPreviousNumber() {
        if (this.props.currentPage > 1) {
            return <Link className="page-numbers" to={this.getLink(this.props.currentPage -1)}>{this.props.currentPage-1}</Link>
        }
        return undefined;
    }

    private renderCurrent() {
        return <span className="page-numbers current">{this.props.currentPage}</span>
    }

    private renderNext() {
        if (this.props.currentPage < this.getLastPage()) {
            return <Link className="next page-numbers" to={this.getLink(this.props.currentPage +1)}>Volgende</Link>
        }
        return undefined;
    }

    private renderNextEllipsis() {
        if (this.props.currentPage + 2 < this.getLastPage()) {
            return <span className="page-numbers">&#8230;</span>;
        }
        return undefined;
    }

    private renderNextNumber() {
        if (this.props.currentPage < this.getLastPage()) {
            return <Link className="page-numbers" to={this.getLink(this.props.currentPage +1)}>{this.props.currentPage+1}</Link>
        }
        return undefined;
    }


    private renderLast() {
        if (this.props.currentPage +1 < this.getLastPage()) {
            return <Link className="page-numbers" to={this.getLink(this.getLastPage())}>{this.getLastPage()}</Link>
        }
        return undefined;
    }

    private getLastPage(): number {
        return Math.ceil(this.props.totalResults / this.props.pageSize);
    }

    private getLink(page: number) {
        return `/${this.props.entityId}/zoeken/pagina/${page}${this.props.search}`;
    }
}

export default withRouter(Pagination);


// WEBPACK FOOTER //
// ./src/components/Pagination.tsx